"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xformFeatureFlags = xformFeatureFlags;
function xformFeatureFlags(flagData) {
  return flagData.reduce(function (acc, flag) {
    acc[flag.Name] = flag.Value === 'true';
    return acc;
  }, {});
}